import { SegButton, Wrap } from "./styles.ts";

type Option = { value: string; label: string };

type Props = {
  value: string;
  onChange: (val: string) => void;
  options: Option[];
  className?: string;
};

export const Segmented = ({ value, onChange, options, className }: Props) => {
  return (
    <Wrap className={className}>
      {options.map((o) => (
        <SegButton
          key={o.value}
          $active={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </SegButton>
      ))}
    </Wrap>
  );
};
